import { Component, OnInit } from '@angular/core';
import { dashboardTabs } from '../../enums/dashboard.enum';

@Component({
  selector: 'app-dashboard-tabs',
  templateUrl: './dashboard-tabs.component.html',
  styleUrls: ['./dashboard-tabs.component.scss']
})
export class DashboardTabsComponent implements OnInit {
  list = [...dashboardTabs];
  constructor() { console.log(this.list[0].link);
  }

  ngOnInit(): void {
  }

}
